import React, { useEffect, useState } from "react";
import { getBlogPosts } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { motion } from "framer-motion";
import { Calendar, ArrowRight, BookOpen, Tag } from "lucide-react";
import { Link } from "react-router-dom";

export default function BlogPage() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    getBlogPosts().then((res) => setPosts(res.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="blog-page" className="bg-[#FAFAFA] min-h-screen">
      <Navbar />
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1670B9] via-[#2d8fd4] to-[#74CDD9] pt-32 pb-20 text-center">
        <h1 className="font-['Quicksand'] text-4xl sm:text-5xl font-light text-white mb-4" data-testid="blog-title">
          Blog
        </h1>
        <p className="text-white/80 text-base max-w-xl mx-auto">
          Articles, réflexions et actualités de notre unité de recherche
        </p>
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 py-16">
        {posts.length === 0 ? (
          <div className="text-center py-20 text-slate-400">
            <BookOpen className="w-16 h-16 mx-auto mb-4 text-slate-300" />
            <p className="text-xl font-['Quicksand']">Aucun article pour le moment</p>
            <p className="text-sm mt-2">Les articles de blog seront ajoutés via le panneau d'administration.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((post, i) => (
              <motion.div
                key={post.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group bg-white rounded-xl border border-slate-100 overflow-hidden hover:shadow-md hover:-translate-y-1 transition-all duration-300"
                data-testid={`blog-card-${i}`}
              >
                {post.image_url && (
                  <div className="h-48 overflow-hidden">
                    <img
                      src={post.image_url}
                      alt={post.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                )}
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3 flex-wrap">
                    {post.tags?.map((tag) => (
                      <span key={tag} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-[#74CDD9]/10 text-[#1670B9] text-xs font-medium">
                        <Tag className="w-3 h-3" />{tag}
                      </span>
                    ))}
                    {post.created_at && (
                      <span className="flex items-center text-xs text-slate-400 gap-1">
                        <Calendar className="w-3 h-3" />
                        {new Date(post.created_at).toLocaleDateString("fr-FR")}
                      </span>
                    )}
                  </div>
                  <h3 className="font-['Quicksand'] text-lg font-semibold text-slate-800 mb-2 line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-sm text-slate-500 leading-relaxed mb-4 line-clamp-3">
                    {post.summary}
                  </p>
                  <Link
                    to={`/blog/${post.id}`}
                    className="inline-flex items-center gap-2 text-sm font-semibold text-[#1670B9] hover:gap-3 transition-all"
                  >
                    Lire l'article <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
